<template>
  <div>
    <div class="button-group">
      <button v-if="prevPageToken" v-on:click="prevPage" class="button">Prev</button>
      <button v-if="nextPageToken" v-on:click="nextPage" class="button">Next</button>
    </div>
    <div class="videos">
      <div v-bind:key="video.id.videoId" v-for="video in this.videosList">
        <Video v-bind:video="video"></Video>
      </div>
    </div>
    <div class="button-group">
      <button v-if="prevPageToken" v-on:click="prevPage" class="button">Prev</button>
      <button v-if="nextPageToken" v-on:click="nextPage" class="button">Next</button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Video from "./Video";

export default {
  name: "Videos",
  components: {
    Video
  },
  data() {
    return {
      videosList: [],
      nextPageToken: "",
      prevPageToken: "",
      src: "https://www.googleapis.com/youtube/v3/search?part=snippet&type=video&order=date",
      channelId: "channelId=UCltyfUM94CjhCEMDJah1mag",
      maxResults: "maxResults=4",
      key: "key=AIzaSyCKpteVE5B7iYcMZ-eOs8v8yfruUWRNXYg"
    };
  },
  created() {
    axios.get(this.src + "&" + this.channelId + "&" + this.maxResults + "&" + this.key).then(response => {
      this.videosList = response.data.items;
      this.nextPageToken = response.data.nextPageToken ? response.data.nextPageToken : "";
      this.prevPageToken = response.data.prevPageToken ? response.data.prevPageToken : "";
    });
  },

  methods: {
    nextPage() {
      axios.get(this.src + "&" + this.channelId + "&" + this.maxResults + "&pageToken=" + this.nextPageToken + "&" + this.key).then(response => {
        this.videosList = response.data.items;
        this.nextPageToken = response.data.nextPageToken ? response.data.nextPageToken : "";
        this.prevPageToken = response.data.prevPageToken ? response.data.prevPageToken : "";
      });
    },

    prevPage() {
      axios.get(this.src + "&" + this.channelId + "&" + this.maxResults + "&pageToken=" + this.prevPageToken + "&" + this.key).then(response => {
        this.videosList = response.data.items;
        this.nextPageToken = response.data.nextPageToken ? response.data.nextPageToken : "";
        this.prevPageToken = response.data.prevPageToken ? response.data.prevPageToken : "";
      });
    }
  }
};
</script>

<style>
.videos {
  display: grid;
  grid-gap: 10px 10px;
  grid-template-columns: auto auto;
  grid-template-rows: auto auto;
}

.button-group {
  text-align: center;
}

.button {
  background-color: #6495ed;
  color: white;
  border: none;
  padding: 10px 20px;
  text-align: center;
  border-radius: 12px;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  transition-duration: 0.4s;
  cursor: pointer;
}

.button:hover {
  background-color: #008b8b;
  color: white;
}

button:focus {
  outline: none;
}

@media screen and (max-width: 1100px) {
  .videos {
    grid-template-columns: auto;
    grid-template-rows: auto auto auto auto;
  }
}
</style>
